import JwtDecode from 'jwt-decode';
import axios, { CancelToken } from 'axios';
import authRequest from '../shared/authRequest';

const validExpiredToken = () => {
  const token = localStorage.getItem('tkn');

  if (!token) return null;
  const timeNow = new Date().getTime() / 1000;
  const { exp } = JwtDecode(token);

  return timeNow < exp;
};

const validRefreshToken = () => {
  const token = localStorage.getItem('refreshToken');

  if (!token) return null;
  const timeNow = new Date().getTime() / 1000;
  const { exp } = JwtDecode(token);

  return timeNow < exp;
};

const validExpiredSSOToken = () => {
  const token = localStorage.getItem('tkn_sso');
  if (!token) return null;
  const timeNow = new Date().getTime() / 1000;
  const { exp } = JwtDecode(token);

  return timeNow < exp;
};

const sendAccessCode = (number, isRut) => {
  const route = isRut ? 'rut' : 'cellphone';
  const reqNumber = isRut ? number : `56${number}`;
  return authRequest([
    {
      url: `auth/challenger/${route}/${reqNumber}`,
      method: 'GET',
    },
  ]);
};

const accessWithCode = (number, code, isRut, contact) => {
  const route = isRut ? 'rut' : 'cellphone';
  const reqNumber = isRut ? number : `56${number}`;
  return authRequest([
    {
      url: `auth/challenger/${route}/${reqNumber}/validate?include=token`,
      method: 'POST',
      data: {
        code,
        contact,
      },
    },
  ]);
};

const validateCode = (number, code, isRut, contact) => {
  const route = isRut ? 'rut' : 'cellphone';
  const reqNumber = isRut ? number : `56${number}`;
  return authRequest([
    {
      url: `auth/challenger/${route}/${reqNumber}/validate`,
      method: 'POST',
      data: {
        code,
        contact,
      },
    },
  ]);
};

const autoProcess = hash => {
  return authRequest([
    {
      url: 'auth/auto-process/cellphone',
      method: 'POST',
      data: {
        hash,
      },
    },
  ]);
};

const updateToken = () => {
  const refreshToken = localStorage.getItem('refreshToken');
  return authRequest([
    {
      url: 'auth/refresh-token',
      method: 'POST',
      data: {
        refreshToken,
      },
    },
  ]);
};

const updateTokenSSO = () => {
  const protocol = `http${process.env.DEFAULT_SECURE && 's'}://`;
  const source = CancelToken.source();

  return axios({
    baseURL: `${protocol}${process.env.LM_BASE_URL}api/loginManager/refresh`,
    cancelToken: source.token,
    headers: {
      'lm-api-key': `${process.env.LM_APIKEY}`,
    },
    method: 'post',
    withCredentials: true,
  });
};

const getAccountId = () => {
  const token = localStorage.getItem('tkn');
  if (!token) return null;

  const { accountId } = JwtDecode(token);

  return accountId;
};

const sendOtpToEmail = ({ email }) =>
  authRequest([
    {
      url: 'auth/otp/email',
      method: 'POST',
      data: { email },
    },
  ]);

const checkReceivedOtpInEmail = ({ email, otp }) =>
  authRequest([
    {
      url: 'auth/otp/email/validate',
      method: 'POST',
      data: { email, otp },
    },
  ]);

const Auth = {
  sendAccessCode,
  accessWithCode,
  autoProcess,
  validateCode,
  validExpiredToken,
  validRefreshToken,
  validExpiredSSOToken,
  updateToken,
  updateTokenSSO,
  getAccountId,
  sendOtpToEmail,
  checkReceivedOtpInEmail,
};

export default Auth;
